import List from 'components/Common/List'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { sortBy } from 'lib/array/arrayUtils'
import React from 'react'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const AmenitiesList = styled(VerticalSpacer)`
  margin-top: 0;

  ${mediaQueryUp.tablet} {
    columns: 2;
  }
`

interface RoomPackageAmenityItem {
  key: string
  description: string
}

export interface RoomPackageAmenityGroup {
  key: string
  title?: string
  items: Array<RoomPackageAmenityItem>
}

export function extractHotelRoomPackageAmenityGroups(roomPackage: App.HotelPackage): Array<RoomPackageAmenityGroup> {
  if (!roomPackage.roomType.amenities.length) return []

  const sortedAmenities = sortBy(
    roomPackage.roomType.amenities.map<RoomPackageAmenityItem>((a) => {
      return { key: `${a.group}-${a.id}`, description: a.description }
    }), a => a.description,
    'asc',
  )

  return [{
    key: `${roomPackage.id}-amenities`,
    items: sortedAmenities,
  }]
}

export function extractBedbankRoomPackageAmenityGroups(roomPackage: App.BedbankPackage): Array<RoomPackageAmenityGroup> {
  return roomPackage.facilityGroups.map<RoomPackageAmenityGroup>((facilityGroup) => {
    return {
      key: facilityGroup.name,
      title: facilityGroup.name,
      items: facilityGroup.values.map<RoomPackageAmenityItem>((v) => ({
        key: v.name,
        description: v.name,
      })),
    }
  })
}

interface Props {
  amenities: Array<RoomPackageAmenityGroup>
}

function AccommodationAmenitiesList(props: Props) {
  const { amenities } = props

  return <AmenitiesList gap={8}>
    {amenities.map(amenity => <div key={amenity.key}>
      {amenity.title && <BodyText variant="medium" weight="bold">{amenity.title}</BodyText>}
      <List>
        {amenity.items.map(item => <BodyText
          key={item.key}
          as="li"
          variant="medium"
        >
          {item.description}
        </BodyText>)}
      </List>
    </div>)}
  </AmenitiesList>
}

export default AccommodationAmenitiesList
